import { Navigate, Outlet } from "react-router";

export default function ExternalRoutes({ externalAuth }) {
  return externalAuth ? <Outlet /> : <Navigate to="/notauthorized" />;
}
